import { render, staticRenderFns } from "./RollHistory.vue?vue&type=template&id=25d9094a&scoped=true"
import script from "./RollHistory.vue?vue&type=script&lang=js"
export * from "./RollHistory.vue?vue&type=script&lang=js"
import style0 from "./RollHistory.vue?vue&type=style&index=0&id=25d9094a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d9094a",
  null
  
)

export default component.exports